<script>
import ManageAccountsAccountConfigurationTrackingServicesView from '@/views/Application/Manage/Accounts/Account/Configuration/TrackingServices'

export default {
  extends: ManageAccountsAccountConfigurationTrackingServicesView,
  data () {
    return {
      breadcrumb: {
        name: 'Track My Parcel',
        route: { name: 'sales-accounts-account-trackingservices', params: this.$route.params }
      }
    }
  }
}
</script>
